import React, { useContext } from "react";

import './cart-quantity-icon-style.scss';

import CartIcon from "@src/componentsNew/Icons/Icons/CartIcon";
import Typography from "@src/componentsNew/Typography/Typography";
import { credentialType, CredentialContext } from "@src/providers";

interface IProps {
  isMobile?: boolean;
  isBottomNav?: boolean;
  isSelected?: boolean;
  onClick?: any;
}

const CartQuantityIcon: React.FC<IProps> = ({ isMobile, isBottomNav, isSelected, onClick }: IProps) => {
  const { currentCart } = useContext<credentialType>(CredentialContext);

  return (
    <div className="cart-quantity-icon-wrapper" onClick={onClick}>
      <CartIcon
        cName="cart-icon"
        fillColor={isBottomNav && isSelected ? '#212121' : ''}
        strokeColor={
          isBottomNav ?
            (isSelected ? '#212121' : '#9E9E9E')
            : ''
        }
      />
      <Typography cName="badge" variant="caption" component="span">
        {(currentCart?.maccaronCart?.quantity || 0) + (currentCart?.mgsCart?.quantity || 0)}
      </Typography>
    </div>
  );
};

export default CartQuantityIcon;
